module.exports = __webpack_public_path__ + "static/media/mock-app-home.daa564aa.svg";